import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SanctumAuthService } from '@freesixtyfive/auth';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    CardModule,
    FloatLabelModule,
    InputTextModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  public email = '';
  public isSent = signal(false);
  #auth = inject(SanctumAuthService);
  #translate = inject(TranslateService);
  #messageService = inject(MessageService);

  public submit(e: any) {
    e.preventDefault();
    const validation = { isValid: true, brokenRules: [{ message: null }] };

    if (validation && validation.isValid) {
      this.#auth
        .forgotPassword<{ message: string }>({ email: this.email })
        .subscribe({
          error: () => {
            this.#messageService.add({
              severity: 'error',
              summary: this.#translate.instant('error.forgotPasswordFailed'),
              detail: this.#translate.instant(
                'error.forgotPasswordFailedDetail',
              ),
            });
            this.isSent.set(false);
          },
          next: ({ message }: { message: string }) => {
            this.isSent.set(true);
            if (message) {
              this.#messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: this.#translate.instant(message),
              });
            }
          },
        });
    } else if (validation && validation.brokenRules instanceof Array) {
      this.#messageService.add({
        severity: 'error',
        summary: 'Login Failed',
        detail: validation.brokenRules.map((x) => x.message).join('. '),
      });
    }
  }
}
